module.exports = __webpack_public_path__ + "static/media/LeftCalendarArrow.08b6be03.svg";